import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';

export const useApiTracking = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const getTracking = async (IdOrden?: number, StartDate?: Date, EndDate?: Date, OrderNumber?: string, TypeTest?: number) => {
    const filters = { IdOrden, StartDate, EndDate, OrderNumber, TypeTest };
    return runApi('Tracking/getTracking', 'GET', filters, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        if (res.internalCode === 111) {
          newToast('INFO', res.data.Error, 5);
          return [];
        }
        return res.data;
      }
    });
  };

  const getAllStates = async () => {
    return runApi('Tracking/getAllStates', 'GET').then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const getSampleTypes = async () => {
    return runApi('Tracking/getSampleTypes', 'GET').then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const setTracking = async (data: any) => {
    return runApi('Tracking/setTracking', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const discartTracking = async (data: any) => {
    return runApi('Tracking/discartTracking', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const rollbackTracking = async (IdOrd: number, IdTk: number, Note: string) => {
    return runApi('Tracking/RollbackTracking', 'POST', { IdOrd, IdTk, Note }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const getBarcodes = async () => {
    return runApi('Tracking/getBarcodes', 'GET').then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  return { getTracking, getAllStates, getSampleTypes, setTracking, discartTracking, rollbackTracking, getBarcodes };
};
